export enum BasketMode {
  Pre,
  Post,
}

export function getBasketMode({
  isShipFromStore,
  expressCheckoutEnabled,
  brandName,
}: {
  isShipFromStore: boolean;
  expressCheckoutEnabled: boolean;
  brandName?: string;
}): BasketMode {
  return isShipFromStore ||
    expressCheckoutEnabled ||
    brandName?.toLowerCase() === "apple"
    ? BasketMode.Pre
    : BasketMode.Post;
}
